var search_dropdown = (function( $ ) {

	var $dropdown;
	var anim_speed = 400;
	var $content;

	var _init = function() {
		$dropdown = $( '#header-search-dropdown' );
		$content = $( '#content' );

		var $toggle_links = $( '.toggle-header-dropdown' );

		$toggle_links.each( function( index, item ) {
			var $link = $( item );

			$link.on( 'click', function( e ) {
				e.preventDefault();

				_toggle_dropdown();
			} );

			$link.addClass( 'setup-header-dropdown-click-event' );
		} );
	};

	var _toggle_dropdown = function() {
		if ( $dropdown.hasClass( 'animating' ) ) {
			return;
		}

		$dropdown.addClass( 'animating' );

		if ( $dropdown.hasClass( 'open' ) ) {
			_close_dropdown()
		} else {
			_open_dropdown();
			$( '.search-input' ).focus();
		}

		setTimeout( function() {
			$dropdown.removeClass( 'animating' );
		}, anim_speed )
	};

	var _close_dropdown = function() {
		$dropdown.removeClass( 'open' );
		$content.removeClass( 'search-open' );

		$dropdown.slideUp( anim_speed );
	};

	var _open_dropdown = function() {
		$dropdown.addClass( 'open' );
		$content.addClass( 'search-open' );

		$dropdown.slideDown( anim_speed );
	}

	$( document ).ready( _init );

})( jQuery );

module.exports = search_dropdown;